import { render, staticRenderFns } from "./PopUpModal.vue?vue&type=template&id=e0ad8074&scoped=true&"
import script from "./PopUpModal.vue?vue&type=script&lang=js&"
export * from "./PopUpModal.vue?vue&type=script&lang=js&"
import style0 from "./PopUpModal.vue?vue&type=style&index=0&id=e0ad8074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ad8074",
  null
  
)

export default component.exports